<template>
  <div class="badgeDoc">
    <grid-card :min="150" :column="'auto-fill'" :gap="10">
      <template slot="item">
        <div class="button-wrapper">
          <button class="btn-block secondary">Cart</button>
          <badge :number="3" />
        </div>
        <div class="button-wrapper">
          <button class="btn-block warning">Cart</button>
          <badge :number="10" />
        </div>
      </template>
    </grid-card>
  </div>
</template>

<script>
import Badge from '@/components/Badge'
import GridCard from '@/components/Grid/Card'

export default {
  name: 'adx-badge',
  components: {
    'badge': Badge,
    'grid-card': GridCard
  },
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>